import { render, staticRenderFns } from "./SubjectEditor.vue?vue&type=template&id=294b89d6&scoped=true"
import script from "./SubjectEditor.vue?vue&type=script&lang=js"
export * from "./SubjectEditor.vue?vue&type=script&lang=js"
import style0 from "./SubjectEditor.vue?vue&type=style&index=0&id=294b89d6&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "294b89d6",
  null
  
)

export default component.exports